import React from 'react';

const ErrorMessage = () => (
    <div className='error'>
        <div className='header'>
            <a className='logo' href='https://cielo24.com/' target='_blank' rel='noopener noreferrer'>
                <span>Cielo24</span>
            </a>
        </div>
        <div className='message'>
            <p>There is an error in the passed configuration, please review it.</p>
        </div>
    </div>
);

export default ErrorMessage;



// WEBPACK FOOTER //
// ./scripts/test-page/error.js